// extracted by mini-css-extract-plugin
export default {"number":"getMobileMenu-module__number__QEwc1","wishListHeart":"getMobileMenu-module__wishListHeart__vHNoI"};